module.exports = __webpack_public_path__ + "img/172420 Backup.80919885.png";